import React, { useEffect, useState } from 'react';
import { Cloud, Menu, X } from 'lucide-react';

const LandingNav = ({ user, onLoginClick, onDashboardClick, onNavigate }) => {
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [solid, setSolid] = useState(false);

  useEffect(() => {
    const root = document.querySelector('.landing-page');
    if (!root) return undefined;

    let lastY = root.scrollTop;
    let ticking = false;

    const update = () => {
      const y = Math.max(0, root.scrollTop);
      const hero = root.querySelector('.lp-screen-hero');
      const heroBottom = hero ? hero.offsetTop + hero.offsetHeight : window.innerHeight;
      const inHero = y < heroBottom - 72;
      const delta = y - lastY;

      if (open) {
        setHidden(false);
        setSolid(!inHero);
        lastY = y;
        ticking = false;
        return;
      }

      if (inHero) {
        setSolid(false);
        setHidden(false);
      } else {
        setSolid(true);
        if (delta > 14 && y > 140) {
          setHidden(true);
        } else if (delta < -14) {
          setHidden(false);
        }
      }

      lastY = y;
      ticking = false;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    root.addEventListener('scroll', onScroll, { passive: true });
    update();
    return () => root.removeEventListener('scroll', onScroll);
  }, [open]);

  const go = (e, id) => {
    onNavigate(e, id);
    setOpen(false);
  };

  const navClass = [
    'lp-nav',
    solid ? 'is-solid' : 'is-transparent',
    hidden && !open ? 'is-hidden' : '',
    open ? 'is-open' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <header className={navClass}>
      <div className="lp-nav-inner">
        <div className="lp-brand">
          <span className="lp-brand-icon" aria-hidden="true">
            <Cloud size={20} />
          </span>
          <span className="lp-brand-text">Devorants</span>
        </div>

        <nav className="lp-nav-links" aria-label="Primary">
          <a href="#features" onClick={(e) => go(e, 'features')}>Features</a>
          <a href="#pricing" onClick={(e) => go(e, 'pricing')}>Pricing</a>
          <a href="#docs" onClick={(e) => e.preventDefault()}>Documentation</a>
          <a href="#community" onClick={(e) => go(e, 'community')}>Community</a>
        </nav>

        <div className="lp-nav-actions">
          {user ? (
            <button type="button" className="lp-btn lp-btn-primary" onClick={onDashboardClick}>
              Go to Dashboard
            </button>
          ) : (
            <>
              <button type="button" className="lp-btn lp-btn-ghost" onClick={() => onLoginClick('hobby', false)}>
                Sign in
              </button>
              <button type="button" className="lp-btn lp-btn-primary" onClick={() => onLoginClick('hobby', true)}>
                Sign up
              </button>
            </>
          )}
          <button
            type="button"
            className="lp-nav-toggle"
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open ? (
        <div className="lp-nav-drawer">
          <a href="#features" onClick={(e) => go(e, 'features')}>Features</a>
          <a href="#pricing" onClick={(e) => go(e, 'pricing')}>Pricing</a>
          <a href="#docs" onClick={(e) => { e.preventDefault(); setOpen(false); }}>Documentation</a>
          <a href="#community" onClick={(e) => go(e, 'community')}>Community</a>
          {!user ? (
            <div className="lp-nav-drawer-actions">
              <button type="button" className="lp-btn lp-btn-ghost" onClick={() => { setOpen(false); onLoginClick('hobby', false); }}>
                Sign in
              </button>
              <button type="button" className="lp-btn lp-btn-primary" onClick={() => { setOpen(false); onLoginClick('hobby', true); }}>
                Sign up
              </button>
            </div>
          ) : (
            <button type="button" className="lp-btn lp-btn-primary" onClick={() => { setOpen(false); onDashboardClick(); }}>
              Go to Dashboard
            </button>
          )}
        </div>
      ) : null}
    </header>
  );
};

export default LandingNav;
